import { Record } from 'immutable';
const ReportsFilterRecord = Record({
  dateRange: undefined,
  order: undefined
});
export default ReportsFilterRecord;